import { render } from "./SceneSection.vue?vue&type=template&id=24baadcc&scoped=true"
import script from "./SceneSection.vue?vue&type=script&lang=js"
export * from "./SceneSection.vue?vue&type=script&lang=js"

import "./SceneSection.vue?vue&type=style&index=0&id=24baadcc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24baadcc"]])

export default __exports__